export default {
    manage_createEditWorkOrderStatus_editTitle: "Editar Estado de la Orden de Trabajo",
    manage_createEditWorkOrderStatus_createTitle: "Crear Nuevo Estado de la Orden de Trabajo",
    manage_createEditWorkOrderStatus_createSuccess: "Estado de la orden de trabajo guardada",
    manage_createEditWorkOrderStatus_name: "Nombre",
    manage_createEditWorkOrderStatus_description: "Descripción",
    manage_createEditWorkOrderStatus_duplicatedName: "El nombre ya está en uso",
    manage_createEditWorkOrderStatus_category: "Categoría",
    manage_createEditWorkOrderStatus_todo: "Por Hacer",
    manage_createEditWorkOrderStatus_closed: "Cerrado",
    manage_createEditWorkOrderStatus_inprogress: "En Curso",
    manage_createEditWorkOrderStatus_inroute: "En Ruta",
}